import { Link } from "react-router-dom";

export function BrandName({ className = "h-8" }: { className?: string }) {
  return <img src="/otium-logo.svg" alt="Otium" className={`w-auto ${className}`} data-testid="brand-name" />;
}

export function Logo() {
  return (
    <Link to="/resumen" className="flex shrink-0 items-center" data-testid="brand-logo-link">
      <BrandName className="h-7 sm:h-8" />
    </Link>
  );
}
